import React from "react";

const styles = {
  container: {
    backgroundColor: '#eeeeee',
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '18px',
    marginBottom: '18px',
    padding: '18px',
    fontFamily: 'Arial, Helvetica'
  },
};

const Container = ({children, containerRef}) => {
  return (
    <div ref={containerRef} style={styles.container}>
        {children}
    </div>
  );
}

export default Container;
